<div class="full-height">
  <pp-common-components />

  @if (isTableLoading | async) {
    <div class="siteTable__overlay">
      <pp-spinner ppSize="large" aria-label="Site Table Overlay Spinner" />
    </div>
  }

  <div id="site" class="site" [class.site--no-sidebar]="sidePanel.hidden">
    <div id="siteHeader" data-m-target="Work list menu" class="site__header">
      <pp-timeline-options
        [ppDataFetched]="dataFetched"
        [ppTimelinePointsLength]="timelinePointsLength"
      />
    </div>

    <div class="site__body">
      <div id="timelineView" data-m-target="Work list timeline" class="site__table-wrapper">
        @if (dataFetched) {
          <pp-site-table-timeline />
        }

        @if (!dataFetched) {
          <div>
            <pp-site-table-placeholder />
          </div>
        }
      </div>
    </div>
  </div>
</div>

<router-outlet name="full"></router-outlet>
